// using chakra craeteIcon func, for chakra Icon component
export { default as GlobeIcon } from "./GlobeIcon";
// using react-icons, for chai Icon component
export { BsQuestionCircleFill, BsTelegram } from "react-icons/bs";
export { FaDiscord } from "react-icons/fa";
export { MdEmail } from "react-icons/md";
// using svg file directly, for Nextjs Image component
export { default as AvalancheIcon } from "public/images/avalanche-icon.svg";
export { default as ExternalLinkIcon } from "public/images/external-link.svg";
export { default as CalendarIcon } from "public/images/fluent-calendar.svg";
export { default as LocationIcon } from "public/images/fluent-location.svg";
export { default as GcpIcon } from "public/images/gcp-icon.svg";
export { default as GoIcon } from "public/images/go-arrow.svg";
export { default as MoongateIcon } from "public/images/moongate-icon.svg";
export { default as SimleFaceIcon } from "public/images/simle-face.svg";
export { default as TimeIcon } from "public/images/time.svg";
export { default as PublicIcon } from "public/images/public-icon.svg";
export { default as Loader } from "public/images/loading.gif";
